import { useEffect, useState } from 'react';

import type { QuickViewProductData } from '@/widgets/QuickView';
import QuickView from '@/widgets/QuickView';

const QuickViewState = () => {
  /**
   * TARGET: PFSN-50370
   * Detach Cart and QuickView
   */

  const [quickViewState, setQuickViewState] = useState<{
    data: QuickViewProductData;
    type: 'full' | 'mini';
  }>();

  const openQuickView = (data: QuickViewProductData, type: 'mini' | 'full') => {
    setQuickViewState({ data, type });
  };

  const closeQuickView = () => {
    setQuickViewState(undefined);
  };

  useEffect(() => {
    window.addEventListener('boost-sd-open-quick-view', (e) => {
      const { productData, type } = e.detail;

      openQuickView(productData, type);
    });

    return () => {
      window.removeEventListener('boost-sd-open-quick-view', (e) => {
        const { productData, type } = e.detail;

        openQuickView(productData, type);
      });
    };
  }, []);

  return (
    <QuickView
      key={quickViewState?.data?.id}
      isOpen={!!quickViewState?.data}
      productData={quickViewState?.data}
      isMini={quickViewState?.type === 'mini'}
      handleCloseModalQuickView={closeQuickView}
    />
  );
};

export { QuickViewState };
